module.exports = __webpack_public_path__ + "img/bg-server.11c73b80.png";